var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuntrustLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 37,
    viewBox: "0 0 64 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82605 24.6713C3.10109 24.6713 1.76227 26.1306 1.77048 27.9866C1.78122 29.9399 3.09353 30.6791 5.10015 31.1762C7.19831 31.6966 7.9886 32.0159 8.00374 33.1402C8.01258 34.0434 7.39085 35.0955 5.542 35.0729C4.29724 35.0553 3.56694 34.6279 3.08026 34.0201C2.90289 33.7857 2.80883 33.4903 2.76465 33.2188C2.71794 32.9291 2.7173 32.6588 2.70153 32.3546H1.84939V35.0257C2.46419 35.4801 4.0435 35.9528 5.55778 35.9528C8.32314 35.9528 9.55212 34.5072 9.72381 32.9203C9.84247 31.821 9.73201 30.9097 8.99791 30.1706C8.44812 29.6326 7.55369 29.2995 5.87339 28.9293C3.86107 28.4925 3.48991 28.0469 3.50633 27.091C3.52337 26.1357 4.4437 25.5795 5.58934 25.5354C6.40866 25.4996 7.05565 25.6046 7.73548 26.0697C7.94125 26.2098 8.12556 26.5033 8.19311 26.8396C8.25307 27.118 8.26065 27.4624 8.27201 27.7038H9.06103V25.3312C8.33703 24.9824 7.46281 24.6713 5.82605 24.6713ZM25.4095 24.8598V27.7038H23.3107V28.2223H23.5159C24.1086 28.2223 24.1787 28.385 24.1787 28.7722V33.7373L20.8016 27.7038H15.4837V28.2223H15.6888C16.2872 28.2223 16.3516 28.3253 16.3516 28.7093V32.9674C16.3516 33.9208 16.2209 35.3155 14.5368 35.2614C13.0352 35.2193 12.9588 34.1018 12.9588 33.1088V28.7093C12.9588 28.3253 13.2012 28.2223 13.7951 28.2223V27.7038H10.1499V28.2223C10.7432 28.2223 10.9862 28.3253 10.9862 28.7093V32.8417C10.9862 33.9831 11.216 34.7417 11.6648 35.2143C12.4216 35.9616 13.6613 35.9528 14.237 35.9528C16.9809 35.9528 17.1248 34.0057 17.1248 32.3389V28.2223C17.1248 28.3404 17.1639 28.2223 17.756 28.2223H18.2294C18.8215 28.2223 18.8607 28.3253 18.8607 28.7093V34.6958C18.8607 35.0735 18.7912 35.23 18.1979 35.23H17.9927V35.7328H20.5176V35.23H20.3125C19.7191 35.23 19.6497 35.0735 19.6497 34.6958V29.6678L23.0582 35.7328H24.9677V28.7722C24.9677 28.3888 25.0327 28.2223 25.6305 28.2223H26.2143V27.3267C26.2143 26.5624 26.2661 25.6769 27.3979 25.6769H28.6603V34.2872C28.6603 35.0107 28.4987 35.23 27.6661 35.23H27.3821V35.7328H32.2109V35.23H31.9426C31.1025 35.23 30.9169 35.0106 30.9169 34.2872V25.6769H32.1793C33.2934 25.6769 33.3471 26.5624 33.3471 27.3267V28.2223H34.1361C34.7402 28.2223 34.7831 28.3574 34.7831 28.7408V34.7115C34.7831 35.0936 34.5274 35.23 33.9152 35.23V35.7328H37.6551V35.23C37.0485 35.23 36.7872 35.0936 36.7872 34.7115V28.3323H37.7656C38.5426 28.3323 39.1227 28.6107 39.1227 29.7935C39.1227 30.5364 38.8248 31.3805 37.7498 31.3805H37.1501C37.1502 31.3805 38.6341 34.352 38.9018 34.9C39.2483 35.5889 39.6763 35.7328 40.5271 35.7328H41.9947V35.23C41.7896 35.23 41.385 35.1954 41.1584 34.8372L39.4067 31.8047C40.3864 31.6004 41.0952 30.8513 41.0952 29.7778C41.0952 27.8056 39.1208 27.7038 37.8287 27.7038H34.1519V24.8598H25.4095ZM52.4098 27.4681C50.5506 27.5897 49.6705 28.7294 49.664 29.9821C49.6564 31.4138 50.3691 32.0724 52.1257 32.4803C53.8913 32.8807 54.3823 33.0384 54.3981 33.9573C54.4076 34.5977 53.825 35.2998 52.5518 35.2771C51.5482 35.2602 51.0079 34.8906 50.7213 34.5544C50.5704 34.3765 50.5092 34.1854 50.4688 33.973C50.4246 33.6983 50.4316 33.4941 50.4215 33.2659H49.6956V35.2457C50.1646 35.5813 51.3809 35.9528 52.536 35.9528C54.6355 35.9528 55.6688 34.8208 55.7868 33.5016C55.8644 32.6808 55.6858 31.9775 55.2029 31.4747C54.7434 31.0078 54.1892 30.8236 52.8201 30.5477C51.3045 30.2385 50.9996 29.9839 51.0053 29.2593C51.0053 28.5082 51.8764 28.1688 52.536 28.1437C53.0246 28.123 53.7442 28.133 54.2877 28.5836C54.4758 28.7408 54.5395 28.957 54.5559 29.1807C54.5812 29.4183 54.595 29.6508 54.6033 29.8406H55.3134V27.9709C54.7232 27.6924 54.0673 27.4819 52.8043 27.4681C52.6716 27.4668 52.5337 27.46 52.4098 27.4681ZM41.5213 27.7038V28.2223C42.1159 28.2223 42.3577 28.3253 42.3577 28.7093V32.8417C42.3577 33.9831 42.5818 34.7417 43.052 35.2143C43.7937 35.9616 45.0271 35.9528 45.6084 35.9528C48.3687 35.9528 48.512 34.0151 48.512 32.8417V28.7408C48.512 28.3568 48.5783 28.2223 49.159 28.2223H49.3642V27.7038H46.8551V28.2223H47.0602C47.6542 28.2223 47.723 28.3568 47.723 28.7408V32.9674C47.723 33.9208 47.5923 35.3155 45.9083 35.2614C44.4072 35.2193 44.3302 34.1018 44.3302 33.1088V28.7093C44.3302 28.3253 44.5751 28.2223 45.1666 28.2223V27.7038H41.5213ZM55.9446 27.7038V29.8406H56.6389C56.6484 29.4566 56.6459 28.9092 56.7967 28.6936C56.9343 28.4931 57.1035 28.3951 57.5226 28.3951H58.3117V34.5858C58.3117 34.9673 58.1526 35.23 57.5384 35.23H57.2701V35.7328H61.3099V35.23H61.0417C60.4288 35.23 60.2842 34.9673 60.2842 34.5858V28.3951H61.0732C61.4867 28.3951 61.6615 28.4931 61.7991 28.6936C61.9519 28.9092 61.9481 29.4566 61.9569 29.8406H62.667V27.7038H55.9446Z",
    fill: "#003366"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.01053 13.9346H10.4901V21.4709H9.01053V13.9346Z",
    fill: "url(#paint0_linear_277_7966)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5576 14.9164H11.3056V20.0858H10.5576V14.9164Z",
    fill: "url(#paint1_linear_277_7966)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6118 9.69796H12.486V18.747H11.6118V9.69796Z",
    fill: "url(#paint2_linear_277_7966)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7063 11.1825H13.7106V18.5334H12.7063V11.1825Z",
    fill: "url(#paint3_linear_277_7966)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7478 6.73086H15.6061V17.2418H13.7478V6.73086Z",
    fill: "url(#paint4_linear_277_7966)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.509 8.22667H16.8818V17.8433H14.509V8.22667Z",
    fill: "url(#paint5_linear_277_7966)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9514 4.97801H21.9827V17.6874H15.9514V4.97801Z",
    fill: "url(#paint6_linear_277_7966)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5029 0.961293H26.8361V16.5121H17.5029V0.961293Z",
    fill: "url(#paint7_linear_277_7966)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6942 3.35709H28.5139V18.0488H17.6942V3.35709Z",
    fill: "url(#paint8_linear_277_7966)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6169 1.21137H34.3217V17.0463H19.6169V1.21137Z",
    fill: "url(#paint9_linear_277_7966)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3486 5.53359H34.6V18.8338H19.3486V5.53359Z",
    fill: "url(#paint10_linear_277_7966)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4631 6.35253H38.8285V18.4617H21.4631V6.35253Z",
    fill: "url(#paint11_linear_277_7966)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5132 12.2012H35.9868V20.1278H20.5132V12.2012Z",
    fill: "url(#paint12_linear_277_7966)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4277 15.7353H38.0882V20.7086H22.4277V15.7353Z",
    fill: "url(#paint13_linear_277_7966)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5402 20.0411H35.557V22.0806H21.5402V20.0411Z",
    fill: "url(#paint14_linear_277_7966)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5878 3.34517H20.2316V16.5442H15.5878V3.34517Z",
    fill: "url(#paint15_linear_277_7966)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_277_7966",
    x1: 31.4178,
    y1: -1.61372,
    x2: 13.0848,
    y2: 15.0578,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_277_7966",
    x1: 31.5811,
    y1: -0.971935,
    x2: 13.5442,
    y2: 15.4304,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_277_7966",
    x1: 29.551,
    y1: -1.43137,
    x2: 12.5331,
    y2: 14.0444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_277_7966",
    x1: 30.9661,
    y1: -1.07862,
    x2: 13.289,
    y2: 14.9966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_277_7966",
    x1: 30.1173,
    y1: -1.92137,
    x2: 12.6268,
    y2: 13.9841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_277_7966",
    x1: 31.5615,
    y1: -1.32986,
    x2: 13.4575,
    y2: 15.1335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_277_7966",
    x1: 27.3337,
    y1: 3.62773,
    x2: 13.6463,
    y2: 16.0748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_277_7966",
    x1: 29.3585,
    y1: 2.05107,
    x2: 13.7568,
    y2: 16.2388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_277_7966",
    x1: 30.9829,
    y1: 3.38012,
    x2: 15.3123,
    y2: 17.6305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_277_7966",
    x1: 33.4,
    y1: 2.93302,
    x2: 16.032,
    y2: 18.7271,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_277_7966",
    x1: 35.8572,
    y1: 4.60329,
    x2: 18.0394,
    y2: 20.8063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_277_7966",
    x1: 37.9641,
    y1: 6.28104,
    x2: 19.7099,
    y2: 22.8809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_277_7966",
    x1: 38.7064,
    y1: 7.76738,
    x2: 20.8096,
    y2: 24.0423,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_277_7966",
    x1: 40.5704,
    y1: 9.87856,
    x2: 22.8153,
    y2: 26.0246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_277_7966",
    x1: 41.0569,
    y1: 10.2176,
    x2: 23.1181,
    y2: 26.5308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_277_7966",
    x1: 26.1411,
    y1: 2.36651,
    x2: 12.3078,
    y2: 14.9461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F15D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDB913"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuntrustLogo);
export default __webpack_public_path__ + "static/media/suntrustLogo.7b6792396ace2c186063cb02a787fa5b.svg";
export { ForwardRef as ReactComponent };